module.exports = __webpack_public_path__ + "img/d71a489.jpg";